import "./CompanyRegistration.scss"

export class CompanyRegistration {
    plz: string;
    ort: string;

    constructor(plz: string, ort: string) {
        this.plz = plz;
        this.ort = ort;
    }

    plzSelected = (e) => {
        this.Ort.value(e.dataItem.Ort);
    }

    ortSelected = (e) => {
        this.Plz.value(e.dataItem.Plz);
    }

    get Plz(): kendo.ui.MultiSelect {
        return $(this.plz).data().kendoAutoComplete;
    }

    get Ort(): kendo.ui.MultiSelect {
        return $(this.ort).data().kendoAutoComplete;
    }
}
